var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeCoverLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 197.85 197.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .we-cover-left-1 {\n        fill: #799dab;\n      }\n\n      .we-cover-left-1, .we-cover-left-2 {\n        stroke-width: 0px;\n      }\n\n      .we-cover-left-3 {\n        clip-path: url(#clippath);\n      }\n\n      .we-cover-left-2 {\n        fill: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "we-cover-left-2",
    width: 197.85,
    height: 197.85
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "We_Cover_Left_1",
    "data-name": "We Cover Left 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "we-cover-left-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "we-cover-left-1",
    d: "M183.97,102.58h0c-.04,32.3-26.25,58.51-58.55,58.54l-176.59.2c-32.3.04-58.46-26.11-58.42-58.41h0c.04-32.3,26.25-58.51,58.55-58.54l176.59-.2c32.3-.04,58.46,26.11,58.42,58.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeCoverLeft);
export default __webpack_public_path__ + "static/media/WeCover-Left.40657723d62ba279ed9147014e4e018c.svg";
export { ForwardRef as ReactComponent };